import routes from '@/router/routes';
import { createRouter, createWebHashHistory } from 'vue-router';
import { isUUID } from '@/utils/isUUID';
import {
  destroyAllModals,
  destroyOpenFilters,
  closeAllDrawers,
  closeAllMenus,
  closeAllTooltips,
} from '@inscribe/signal';
import qs from 'qs';
import { OnboardingService } from '@/shared/services/onboarding/onboarding.service';

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  parseQuery: qs.parse,
});

router.beforeEach(async (to, from, next) => {
  // close all existing elements in page
  closeAllTooltips();
  destroyAllModals();
  destroyOpenFilters();
  closeAllDrawers();
  closeAllMenus();

  // Prevent anything but a number being inserted in place of IDs in URL
  const areAnyParamsInvalid = !Object.keys(to.params)
    .filter((key) => key.endsWith('_id'))
    .map((key) => to.params[key])
    .every((param) => {
      return !isNaN(param) || isUUID(param);
    });
  if (areAnyParamsInvalid) {
    return next({ path: '/' });
  }

  next();
});

router.afterEach((to) => {
  OnboardingService.onRouteChange(to);
});

export default router;
